import { StateService } from '@uirouter/angular';
import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UiService } from '../../core/services/core.ui.service'; 
import { doGetPromise } from '../../core/config/core.httpclient-utils';

@Component({
  selector: 'gf-commit-association',
  template: require('./gf-commit-association.component.html')
})
export class CommitAssociationComponent implements OnInit {
  addAssociationSearch: string;
  @Input() commit: any;
  @Input() project: any;
  @Input() allowUpdates: boolean;

  searchAssociationItemsResult: any[] = [];
  searchAssociationSearching = false;
  addAssociationAutoSubmitTimer: any;
  trackeritems: any[] = [];

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private uiService: UiService,
    private stateService: StateService
  ) {}

  ngOnInit() {
    this.fetchAssociations();
  }

  searchTrackerItemsForAssociation(searchValue: string) {
    this.searchAssociationItemsResult = [];

    if (searchValue.length < 3) {
      return;
    }

    this.searchAssociationSearching = true;

    const params = {
      q: searchValue,
      s: 'trackeritem',
      project: this.project.id,
      page_num: 1,
      page_size: 20
    };

    doGetPromise(this.http, `/api/search/`, params)
      .then(response => {
        this.searchAssociationItemsResult = _.sortBy(
          _.get(response, 'items', []),
          ['matchScore', 'title']
        ).reverse();

        this.searchAssociationSearching = false;
      }, error => {
        const errorMsg = this.translate.instant('Sorry, {{searchValue}} does not exists or you are not allowed to view it', {'searchValue' : searchValue});
        const errorMsgTitle = this.translate.instant('Invalid Tracker Item');
        this.uiService.message.showWarning(errorMsg, errorMsgTitle);
        this.searchAssociationSearching = false;
      });
  }

  addAssociationAutoSubmit(searchValue: string) {
    if (this.addAssociationAutoSubmitTimer) {
      clearTimeout(this.addAssociationAutoSubmitTimer);
    }
    this.addAssociationAutoSubmitTimer = setTimeout(() => {
      this.searchTrackerItemsForAssociation(searchValue);
    }, 750);
  }

  addAssociatedItem(item: any) {
    const unixName = this.stateService.params.unixName;
    const url = `/api/scm/${unixName}/association`;
    const params = {
      commitHash: this.commit.id,
      trackerItemId: item.refId
    };

    this.http.post(url, params).subscribe(() => {
      this.fetchAssociations();
    }, error => {
    });
  }

  removeAssociation(ti: any) {
    const unixName = this.stateService.params.unixName;
    const url = `/api/scm/${unixName}/association/${encodeURIComponent(this.commit.id)}/${ti.id}`;

    this.http.delete(url).subscribe(() => {
      _.remove(this.trackeritems, { id: ti.id });
    }, error => {
    });
  }

  private fetchAssociations() {
    const unixName = this.stateService.params.unixName;
    const url = `/api/scm/${unixName}/association/${encodeURIComponent(this.commit.id)}`;

    this.http.get(url).subscribe(response => {
      this.trackeritems = _.get(response, 'items', []);
    }, error => {
    });
  }

  trackById(index: number, item: any): any {
    return item?.id ?? item;
  }
}
